import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p className="text">
          The images shows are for illustrational purposes and may not be an
          exact repersentation of the product.
        </p>
        <p className="text">Enjoy your drinks and please drink responsibly.</p>
      </div>
    </footer>
  );
};

export default Footer;
